import {Injectable} from '@angular/core';
import {firstValueFrom, map} from 'rxjs';
import {PaginatorService} from "@shared/api/services/paginator.service";

@Injectable()
export class GetService<TList, TGet> extends PaginatorService<TList> {

    async getById(id: number): Promise<TGet> {
        let result = this.http.get<any>(this.urlToEntity + '/' + id)
            .pipe(
                map((response) => {
                    return response.data;
                })
            )
        return firstValueFrom(result)
    }
}
